import { FC, useEffect } from "react";
import { motion } from "framer-motion";
import { ExperienceContent } from "./Content";
import styled from "styled-components/macro";
import {
  StyledPageWrapper,
  ContentWrapper,
  PageTitle,
  Divider,
} from "./StyledComponents";
import BackButton from "./BackButton";

const JobLink = styled.a`
  color: inherit;
  text-decoration: inherit;
  display: block;
  transition: all 0.3s ease;
  padding-bottom: 50px;
  :hover {
    .MuiSvgIcon-root {
      transform: translate(5px, -5px);
      transition: all 0.5s ease-in-out;
    }
  }
`;

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    width: "90%",
    transition: {
      staggerChildren: 0.22,
      delayChildren: 0.15,
      ease: [0.16, 1, 0.3, 1], // cubic-bezier
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.98,
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

interface ExperienceType {
  jobs: Array<{
    title: string;
    companyName: string;
    description: string;
    date?: string;
    img: string;
    url: string;
    tech?: string[];
    category: string;
  }>;
  title: string;
}

const ExperiencePage: FC<ExperienceType> = ({ jobs, title }) => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  });

  return (
    jobs && (
      <motion.div
        key={title}
        variants={containerVariants}
        initial="hidden"
        animate="show"
      >
        <StyledPageWrapper>
          <ContentWrapper>
            <BackButton to="/portfolio" title="Back to Portfolio" />

            <PageTitle className='title-page'>{title}</PageTitle>

            <Divider />

            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="show"
            >
              {jobs.map((job, idx) => (
                <motion.div key={`${job.companyName}-${idx}`} variants={fadeUp}>
                  <JobLink target="_blank" rel="noreferrer" href={job.url}>
                    <ExperienceContent contentData={job} />
                  </JobLink>
                </motion.div>
              ))}
            </motion.div>
          </ContentWrapper>
        </StyledPageWrapper>
      </motion.div>
    )
  );
};

export default ExperiencePage;
